import { get } from 'lodash'

export const getFormattedRetentionOptions = retentionOptions =>
  retentionOptions && retentionOptions.map(option => get(option, 'text'))
